export const heroAgentSocialProofVariants = {
  TEST: "test",
} as const;

export type HeroAgentSocialProofVariant =
  (typeof heroAgentSocialProofVariants)[keyof typeof heroAgentSocialProofVariants];

export interface BlocksMeta {
  pageSlug?: string | null | undefined;
  heroAgentSocialProofVariant?: HeroAgentSocialProofVariant;
}
